import React from "react";
import { Heading } from "../../../../../../../../../../components/headers/heading/heading.component";
import { formatMoney } from "../../../../../../../../../../utils/format-money.function";
import {
  HeaderLine,
  ProductBox,
  ProductDetail,
  ProductDetailTitle,
  ProductInfo,
  ProductInfoContent,
  ProductInfoDetails,
  ProductName,
  ProductValue,
} from "./flyer-detail-page-form-position-products-table.styles";
import { FlyerDetailPageFormPositionProductsTableProps } from "./flyer-detail-page-form-position-products-table.props";
import { FlyerDetailPageFormPositionProductsTableImage } from "../flyer-detail-page-form-position-products-table-image/flyer-detail-page-form-position-products-table-image.component";
import { ProductHistory } from "../../../../../../../../../../features/product-history/components/product-history.component";
import { BasicResourceType } from "../../../../../../../../../../types/resources/resources.enums";
import { ProductsTableExtras } from "./components/flyer-detail-page-form-position-position-products-table-extras/flyer-detail-page-form-position-position-products-table-extras.component";
import { IBriefProduct } from "../../../../../../../../../../types/product/ibrief-product/ibrief-product.interface";

export const FlyerDetailPageFormPositionProductsTable = (
  props: FlyerDetailPageFormPositionProductsTableProps
) => {
  const isProductActive = (product: IBriefProduct) =>
    !Boolean(props.flyerEndDatePassed) ? product.productDetail.active : true;

  return (
    <>
      <HeaderLine>
        <Heading variant="sub">Products</Heading>
        <ProductHistory
          resourceId={props.positionId}
          resourceType={BasicResourceType.FlyerPagePosition}
        />
      </HeaderLine>

      {props.products &&
        props.products.map((product, index) => (
          <ProductBox key={index}>
            <FlyerDetailPageFormPositionProductsTableImage imageUrl={product.productDetail.image} />
            <ProductInfo>
              <ProductInfoContent>
                <ProductName active={isProductActive(product)}>
                  {product.productDetail.name}
                </ProductName>
                <div>
                  <ProductInfoDetails>
                    <ProductDetail>
                      <ProductDetailTitle>Promo Price</ProductDetailTitle>
                      <ProductValue>{formatMoney(product.futurePrice)}</ProductValue>
                    </ProductDetail>
                    <ProductDetail>
                      <ProductDetailTitle>Reg Price</ProductDetailTitle>
                      <ProductValue>{formatMoney(product.productDetail.price)}</ProductValue>
                    </ProductDetail>
                    <ProductDetail>
                      <ProductDetailTitle>SKU</ProductDetailTitle>
                      <ProductValue>{product.productDetail.sku}</ProductValue>
                    </ProductDetail>
                  </ProductInfoDetails>
                </div>
              </ProductInfoContent>
            </ProductInfo>
            <ProductsTableExtras product={product} />
          </ProductBox>
        ))}
    </>
  );
};
